import { render, staticRenderFns } from "./LayoutProduct.vue?vue&type=template&id=18fcbd8f&scoped=true&"
import script from "./LayoutProduct.vue?vue&type=script&lang=js&"
export * from "./LayoutProduct.vue?vue&type=script&lang=js&"
import style0 from "./LayoutProduct.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LayoutProduct.vue?vue&type=style&index=1&id=18fcbd8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fcbd8f",
  null
  
)

export default component.exports